<template>
  <div>
    <b-row>
      <b-col>
        <search-box v-model="query" />
      </b-col>
      <b-col class="text-right">
        <b-button
          v-if="
            auth.user.selectedAccess.roleLevel > 2 &&
              auth.user.selectedAccess.can_modify_settings
          "
          v-router-link="{
            name: 'subdistributor-editor',
            query: { distributor_id: $route.params.id },
          }"
          variant="outline-primary"
          size="sm"
        >
          <span v-label-key="'ADD_SUBDISTRIBUTOR'">Add Subdistributor</span>
        </b-button>
      </b-col>
    </b-row>

    <b-table
      id="subdistributor-table"
      ref="subdistributorTable"
      :per-page="0"
      :current-page="currentPage"
      :items="subdistributors"
      :fields="fields"
      :busy="loading"
      show-empty
      striped
      hover
      responsive
      @sort-changed="handleSortChange"
    >
      <template v-slot:cell(name)="data">
        <router-link :to="{ name: 'subdistributor-detail', params: data.item }">
          {{ data.item.name }}
        </router-link>
      </template>
      <template v-slot:cell(distributor_name)="data">
        <router-link
          v-if="auth.user.selectedAccess.roleLevel > 2"
          :to="{
            name: 'distributor-detail',
            params: { id: data.item.distributor_id },
          }"
        >
          {{ data.item.distributor_name }}
        </router-link>
        <span v-if="auth.user.selectedAccess.roleLevel <= 2">{{
          data.item.distributor_name
        }}</span>
      </template>
      <template v-slot:table-busy>
        <loading-spinner />
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="total"
      :per-page="perPage"
      align="right"
      aria-controls="subdistributor-table"
      @change="pageChanged"
    />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import $api from '@/services/api';
import $auth from '@/services/auth';
import $search from '@/services/search';
import LoadingSpinner from '@/components/LoadingSpinner';
import SearchBox from '@/components/SearchBox';
import { mapGetters } from 'vuex';

export default {
  name: 'SubdistributorList',
  components: {
    LoadingSpinner,
    SearchBox,
  },
  props: ['distributor_id'],
  data() {
    return {
      auth: $auth,
      search: $search,
      query: null,
      subdistributors: [],
      perPage: 10,
      currentPage: 1,
      total: 0,
      orderBy: '',
      isOrderByDesc: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
    fields() {
      const fields = [
        { key: 'id', label: 'ID', labelKey: 'ID', sortable: true },
        { key: 'name', label: 'Name', labelKey: 'NAME', sortable: true },
        {
          key: 'distributor_name',
          label: 'Distributor',
          labelKey: 'DISTRIBUTOR',
          sortable: true,
        },
      ];
      fields.forEach(field => {
        if (field.labelKey) {
          field.label = this.getLabel(field.labelKey) || field.label;
        }
      });
      return fields;
    },
    totalRows() {
      return (
        this.$store.state.global.subdistributors &&
        this.search(this.$store.state.global.subdistributors, this.query, [
          'name',
          'subdistributor_name',
        ]).length
      );
    },
  },
  watch:{
    query(newValue) {
      this.debounceSearch(newValue);
    }
  },
  beforeDestroy() {
    if (this.debounceSearch && this.debounceSearch.cancel) {
      this.debounceSearch.cancel();
    }
  },
  created() {
    this.debounceSearch = debounce(() => {
      this.currentPage = 1;
      this.refreshData();
    }, 500);
    this.refreshData();
  },
  methods: {
    pageChanged(page) {
      this.currentPage = page;
      this.refreshData();
    },
    handleSortChange(e){
      this.orderBy = e.sortBy;
      this.isOrderByDesc = e.sortDesc;
      this.refreshData();
    },
    refreshData(){
      this.loading = true;
      this.subdistributors = [];

      let tempQuery = this.getListQuery();

      tempQuery += `&skip=${(this.currentPage - 1) * this.perPage}&take=${
        this.perPage
      }`;

      $api
        .get('/v1/dashboard/subdistributors' + tempQuery)
        .then(response => {
          this.subdistributors = response.data;
          this.total = response.total;
          this.$emit('loaded', response.data);
        })
        .catch(() => {
        }).finally(() => {
          this.loading = false;
          this.$refs.subdistributorTable.refresh();
        });
    },
    getListQuery() {
      const payload = {
        distributor_id: this.distributor_id,
        orderBy: this.orderBy? this.orderBy : null,
        isOrderByDesc: this.orderBy ? this.isOrderByDesc : null,
        searchKey: this.query ? this.query : null,
      };

      let tempQuery = "?";
      for (const key in payload) {
        if (payload[key] !== null && payload[key] !== undefined) {
          tempQuery += `&${key}=${payload[key]}`;
        }
      }

      return tempQuery;
    },
  },
};
</script>

<style scoped>
a {
  color: #000;
}
</style>
